import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7524cba5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controls mb-20" }
const _hoisted_2 = { class: "control-right" }
const _hoisted_3 = {
  key: 1,
  class: "preview-image"
}
const _hoisted_4 = ["src"]

import { onMounted, ref } from 'vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import { getMediaById } from '@/api'
import Hls from 'hls.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewTrailerPlayer',
  props: {
    trailerId: {}
  },
  setup(__props: any) {

const props = __props

const hls = ref()
const containerVideo = ref<HTMLVideoElement | null>(null)
const isPlaying = ref(false)
const trailer = ref()
const isOverLayHidden = ref(false)
const overlayTimer = ref()
const isShowPreviewImage = ref(true)
const volume = ref(1)
const loadTrailerDataAsync = async () => {
  try {
    const { data } = await getMediaById(props.trailerId)
    trailer.value = data
    if (Hls.isSupported()) {
      hls.value = new Hls()
    }
    hls.value.loadSource(trailer.value.hls_info.master_file)
    hls.value.attachMedia(document.getElementById('containerVideo'))
    hls.value.on(Hls.Events.MEDIA_ATTACHED, function () {
      containerVideo.value.volume = volume.value
      containerVideo.value.addEventListener('play', (e) => {
        isShowPreviewImage.value = false
        isPlaying.value = true
        setTimeout(() => {
          isOverLayHidden.value = true
        }, 1000)
      })
      containerVideo.value.addEventListener('pause', () => {
        isPlaying.value = false
        if (overlayTimer.value) {
          clearTimeout(overlayTimer.value)
        }
        isOverLayHidden.value = false
      })
    })
  } catch (e) {
    console.log('Get media error', e)
  }
}
const overlayHandler = () => {
  isOverLayHidden.value = false
  const time = setTimeout(() => {
    if (isPlaying.value) {
      clearTimeout(time)
      isOverLayHidden.value = true
    }
  }, 3000)
}
const toggleVolume = () => {
  volume.value = Number(!volume.value)
  containerVideo.value.volume = volume.value
}
if (props.trailerId) {
  loadTrailerDataAsync()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: overlayHandler,
    class: "player-preview"
  }, [
    (!isOverLayHidden.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(!isPlaying.value ? 'player-preview__overlay player-preview__overlay-black':'player-preview__overlay')
        }, [
          (!isPlaying.value)
            ? (_openBlock(), _createBlock(CircleButton, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (containerVideo.value.play())),
                class: "btn-player__action play",
                bg: "none",
                name: "play",
                iconWidth: 47,
                iconHeight: 47,
                "view-box": "0 0 28.58 39.49"
              }))
            : (_openBlock(), _createBlock(CircleButton, {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (containerVideo.value.pause())),
                class: "btn-player__action play",
                bg: "none",
                name: "pause",
                iconWidth: 47,
                iconHeight: 47,
                "view-box": "0 0 28.58 39.49"
              })),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CircleButton, {
                onClick: toggleVolume,
                name: volume.value ? 'volume':'mute',
                iconWidth: 16,
                iconHeight: 18,
                "view-box": "0 0 16 18"
              }, null, 8, ["name"])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (trailer.value && isShowPreviewImage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            src: trailer.value?.poster_url,
            alt: ""
          }, null, 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("video", {
      playsInline: "",
      ref_key: "containerVideo",
      ref: containerVideo,
      id: "containerVideo",
      class: "player-preview__background"
    }, null, 512)
  ]))
}
}

})